import PropTypes from "prop-types";

interface Props {
  image: string;
  text: string;
  text1: string;
}

export const GalleryCard = ({
  image = "/img/image.png",
  text = "Watch anywhere, anytime directly from the phone<br />in your pocket.",
  text1 = "Phone",
}: Props): JSX.Element => {
  return (
    <div className="flex flex-col w-[222px] items-center justify-center gap-3.5 relative transition-transform duration-250 lg:hover:scale-110 cursor-pointer">
      <img className="relative w-[100px] h-[100px]" alt="Image" src={image} />

      <div className="relative w-[226px] h-[196px] mr-[-4.00px]">
        <p 
          className="absolute w-[222px] h-24 top-[100px] left-0 font-about-carddescription font-[number:var(--about-carddescription-font-weight)] text-[#657d84] text-[length:var(--about-carddescription-font-size)] text-center tracking-[var(--about-carddescription-letter-spacing)] leading-[var(--about-carddescription-line-height)] [font-style:var(--about-carddescription-font-style)]"
          dangerouslySetInnerHTML={{ __html: text }}
        />

        <div className="absolute w-[170px] h-0.5 top-[78px] left-[26px] bg-[#d8dbdd]" />

        <div className="absolute w-[222px] h-[70px] top-0 left-0 font-about-cardtitle font-[number:var(--about-cardtitle-font-weight)] text-[#657d84] text-[length:var(--about-cardtitle-font-size)] text-center tracking-[var(--about-cardtitle-letter-spacing)] leading-[var(--about-cardtitle-line-height)] [font-style:var(--about-cardtitle-font-style)]">
          {text1}
        </div>
      </div>
    </div>
  );
};

GalleryCard.propTypes = {
  image: PropTypes.string,
  text: PropTypes.string,
  text1: PropTypes.string,
}; 